import axios from "axios";
import Config from "../../config";

const actionListaChamadosPorChat = (chatId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chamados/por-chat/${chatId}`
    });
};

export default actionListaChamadosPorChat;
